import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import "hammerjs";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { TranslateModule } from "@ngx-translate/core";

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule } from "@core/components";

import { coreConfig } from "app/app-config";
import { AppComponent } from "app/app.component";
import { DialogComponent } from "./dialog/dialog/dialog.component";
import { LayoutModule } from "app/layout/layout.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";

import { SharedModule } from "./shared/shared.module";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from "ngx-perfect-scrollbar";
import { FormsModule } from "@angular/forms";
import { AuthHttpInterceptor } from "./interceptor/auth-http-interceptor";
import { environment } from "../environments/environment";
import { API_BASE_URL } from "./api/api";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./pages/page.module").then((p) => p.PageModule),
  },
  { path: "**", redirectTo: "" },
];
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const config: ExtraOptions = {
  useHash: false,
};
// const appRoutes: Routes = [
//   {
//     path: 'dashboard',
//     loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule)
//   },
//   {
//     path: 'apps',
//     loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'pages',
//     loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
//   },
//   {
//     path: 'ui',
//     loadChildren: () => import('./main/ui/ui.module').then(m => m.UIModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'components',
//     loadChildren: () => import('./main/components/components.module').then(m => m.ComponentsModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'extensions',
//     loadChildren: () => import('./main/extensions/extensions.module').then(m => m.ExtensionsModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'forms',
//     loadChildren: () => import('./main/forms/forms.module').then(m => m.FormsModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'tables',
//     loadChildren: () => import('./main/tables/tables.module').then(m => m.TablesModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: 'charts-and-maps',
//     loadChildren: () => import('./main/charts-and-maps/charts-and-maps.module').then(m => m.ChartsAndMapsModule),
//     canActivate: [AuthGuard]
//   },
//   {
//     path: '',
//     redirectTo: '/dashboard/ecommerce',
//     pathMatch: 'full'
//   },
//   {
//     path: '**',
//     redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
//   }
// ];

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, DialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 4000,
      preventDuplicates: true,
      progressBar: true,
      maxOpened: 4,
      countDuplicates: true,
    }),
    TranslateModule.forRoot(),
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    LayoutModule,
    ContentHeaderModule,
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    RouterModule.forRoot(routes, config),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    PerfectScrollbarModule,
    NgbModule,
    SharedModule,
  ],
  providers: [
    { provide: API_BASE_URL, useValue: environment.baseUrl },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
  ],
})
export class AppModule {}
